import { UserViewRoles } from '../utils/roles/client-roles';
import { gPanelTiers } from './gPanel-tiers';
import SettingsApplications from '@mui/icons-material/SettingsApplications';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import SchemaOutlined from '@mui/icons-material/SchemaOutlined';
import Groups from '@mui/icons-material/Groups';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import Contacts from '@mui/icons-material/Contacts';
import ContactsOutlined from '@mui/icons-material/ContactsOutlined';
import ContactPhoneOutlined from '@mui/icons-material/ContactPhoneOutlined';
import Settings from '@mui/icons-material/Settings';
interface UserPortalBasePageConfigItem {
  name: string;
  link: string;
  value: string;
  icon: React.ElementType;
  requiredPermission: string;
  requiredPermissionDisplayValue: string;
  roleGroup:
    | 'userRoles'
    | 'calendarRoles'
    | 'driveRoles'
    | 'administrationRoles'
    | 'directoryRoles'
    | 'changeLogRoles'
    | 'toolsRoles'
    | 'billingRoles'
    | 'rulesEngineRoles'
    | 'userViewRoles';

  minimumTier: number;
  minimumTierDisplayValue: string;
}

interface UserPortalPageConfigItem extends UserPortalBasePageConfigItem {
  isGroupDetails?: boolean;
  isLayoutRoute?: boolean;
}

export const userPortalPagesConfig = {
  // userPortalGpanelContacts: {
  //   //TODO place it properly, see commented gpanel-contacts (userPortalGpanelContacts)
  //   name: 'gPanel Contacts',
  //   link: 'gpanel-contacts',
  //   value: 'userPortalGPanelContacts',
  //   icon: Contacts,
  //   requiredPermission: 'TODO',
  //   requiredPermissionDisplayValue: 'TODO userPortalGpanelContacts permission',
  //   roleGroup: 'userViewRoles',
  //   minimumTier: 100, //TODO fix tier
  //   minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
  //   isUserPortal: true,
  // },
  userPortal: {
    name: 'User Portal',
    link: 'userportal',
    value: 'userPortal',
    icon: SettingsApplications,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isLayoutRoute: true,
    isUserPortal: true,
  },
  userPortalProfileInformation: {
    name: 'Profile Information',
    link: 'profile-information',
    value: 'userPortalProfileInformation',
    icon: InfoOutlined,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isUserPortal: true,
  },
  userPortalCustomAttributes: {
    name: 'Custom Attributes',
    link: 'custom-attributes',
    value: 'userPortalCustomAttributes',
    icon: SchemaOutlined,
    requiredPermission: UserViewRoles.ViewCustomAttributes.value,
    requiredPermissionDisplayValue: UserViewRoles.ViewCustomAttributes.name,
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isUserPortal: true,
  },
  userPortalMyGroups: {
    name: 'My Groups',
    link: 'my-groups',
    value: 'userPortalMyGroups',
    icon: GroupsOutlined,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isUserPortal: true,
  },
  userPortalGroupDetails: {
    name: 'Group Details',
    link: 'groups/:groupEmail',
    value: 'userPortalGroupDetails',
    icon: GroupsOutlined,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isLayoutRoute: true,
    isUserPortal: true,
  },
  userPortalGroupGeneralInformation: {
    name: 'General Information',
    link: 'general-information',
    value: 'userPortalGroupGeneralInformation',
    icon: InfoOutlined,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isGroupDetails: true,
    isUserPortal: true,
  },
  userPortalGroupBusinessGroupSettings: {
    name: 'Business Group Settings',
    link: 'business-group-settings',
    value: 'userPortalGroupBusinessGroupSettings',
    icon: Settings,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isGroupDetails: true,
    isUserPortal: true,
  },
  userPortalGroupMembership: {
    name: 'Group Members',
    link: 'membership',
    value: 'userPortalGroupMembership',
    icon: Groups,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isGroupDetails: true,
    isUserPortal: true,
  },
  userPortalAllGroups: {
    name: 'All Groups',
    link: 'all-groups',
    value: 'userPortalAllGroups',
    icon: GroupsOutlined,
    requiredPermission: UserViewRoles.ViewAllGroups.value,
    requiredPermissionDisplayValue: UserViewRoles.ViewAllGroups.name,
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isUserPortal: true,
  },
  userPortalAllGroupsDetails: {
    name: 'All Groups Details',
    link: 'groups/:groupEmail',
    value: 'userPortalAllGroupsDetails',
    icon: GroupsOutlined,
    requiredPermission: UserViewRoles.ViewAllGroups.value,
    requiredPermissionDisplayValue: UserViewRoles.ViewAllGroups.name,
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isLayoutRoute: true,
    isUserPortal: true,
  },
  userPortalPersonalContacts: {
    name: 'Personal Contacts',
    link: 'personal-contacts',
    value: 'userPortalPersonalContacts',
    icon: Contacts,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isUserPortal: true,
  },
  userPortalSharedContacts: {
    name: 'Shared Contacts',
    link: 'shared-contacts',
    value: 'userPortalSharedContacts',
    icon: ContactsOutlined,
    requiredPermission: UserViewRoles.ViewSharedContacts.value,
    requiredPermissionDisplayValue: UserViewRoles.ViewSharedContacts.name,
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isUserPortal: true,
  },
  // userPortalGpanelContacts: {
  //   name: 'gPanel Contacts',
  //   link: 'gpanel-contacts',
  //   value: 'userPortalGPanelContacts',
  //   icon: Contacts,
  //   requiredPermission: UserViewRoles.ViewSharedContacts.value,
  //   requiredPermissionDisplayValue: UserViewRoles.ViewSharedContacts.name,
  //   roleGroup: 'userViewRoles',
  //   minimumTier: gPanelTiers.essentials.rank,
  //   minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
  //   isUserPortal: true,
  // },
  userPortalDirectorySearch: {
    name: 'Directory',
    link: 'directory',
    value: 'userPortalDirectorySearch',
    icon: ContactPhoneOutlined,
    requiredPermission: UserViewRoles.ViewDirectorySearch.value,
    requiredPermissionDisplayValue: UserViewRoles.ViewDirectorySearch.name,
    roleGroup: 'userViewRoles',
    minimumTier: gPanelTiers.essentials.rank,
    minimumTierDisplayValue: gPanelTiers.essentials.displayValue,
    isUserPortal: true,
  },
} as const;

export type UserPortalPagesConfig = typeof userPortalPagesConfig;
export type UserPortalPagesConfigKey = keyof UserPortalPagesConfig;
export { type UserPortalPageConfigItem };

export const allUserPortalPagesWithLayouts: UserPortalPageConfigItem[] =
  Object.keys(userPortalPagesConfig).map(
    (page) => userPortalPagesConfig[page as UserPortalPagesConfigKey]
  );

export const allUserPortalPages: UserPortalPageConfigItem[] =
  allUserPortalPagesWithLayouts.filter((page) => !page.isLayoutRoute);

export const allUserPortalPagesWithoutGroupDetails: UserPortalPageConfigItem[] =
  allUserPortalPages.filter((page) => !page.isGroupDetails);

export const userPortalGroupDetailsPages = allUserPortalPages.filter(
  (page) => page.isGroupDetails
);
